export default class Theme {
  constructor(theme) {
    Object.assign(this, this.createTheme(theme));
  }

  createTheme(theme) {
    return {
      ...theme
    };
  }

  get getLogoIsValid() {
    return this.logo && this.logo !== '';
  }

  get getUpdatedBy() {
    return this.updatedBy;
  }

  get getUpdatedAt() {
    return this.updatedAt;
  }

  get getFont() {
    return this.font;
  }

  get getLogo() {
    return this.logo;
  }

  get getThemeMode() {
    return this.darkMode;
  }

  get getThemeColors() {
    return { dark: this.dark, light: this.light };
  }

  get getOptionalFields() {
    return this.optionalFields;
  }
}

export const maxLogoFileSize = 1572864;
